export default __webpack_public_path__ + "static/media/tutrial2.11bac6cb.jpg";